export class DomainMasterData {
    DomainName:string;
    DomainID:number;
    // CreatedDate:string;
  }